import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { MuiButton, Modal, MuiTextField } from '../../components'
import { findAll } from 'highlight-multiple-words'
import { useGlobalStore } from '../../store'
import { OuterWrapper } from './style'

const Highlighter = ({ type = 'view', text = '' }) => {
  const [showBox, setShowBox] = useState(false)
  const [highlighterValue, setHighlighterValue] = useState('')
  const [chunks, setChunks] = useState()
  const { wordHighlighter, setWordHighlighter } = useGlobalStore()

  const textToHighlight = text

  const showHighlighterModal = () => {
    const wordData = JSON.parse(window.localStorage.wordHighlighter)
    setHighlighterValue(wordData)
    setShowBox(true)
  }

  const addHighlighterFunc = () => {
    setWordHighlighter(highlighterValue)
    setShowBox(false)
  }

  const onLoad = () => {
    if (type === 'add') {
      setHighlighterValue(wordHighlighter)
    } else {
      if (isNaN(wordHighlighter)) {
        const searchWords = wordHighlighter.split(',')
        setChunks(findAll({ searchWords, textToHighlight }))
      }
    }
  }

  useEffect(() => {
    onLoad()
  }, [wordHighlighter])

  useEffect(() => {
    onLoad()
  }, [])

  if (type === 'add') {
    return (
      <>
        <MuiButton onClick={showHighlighterModal} color='secondary' variant='outlined'>Highlighter</MuiButton>
        {
          showBox &&
          <Modal title='' showClose={true} onClose={() => setShowBox(false)}>
            <MuiTextField
                name='itemText'
                placeholder=''
                onChange={(e) => setHighlighterValue(e.target.value)}
                variant='standard'
                value={highlighterValue}
                multiline
                minRows={5}
                maxRows={10}
                style={{ minWidth: '500px' }}
            />
            <MuiButton
              onClick={addHighlighterFunc}
              type='button'
              color='secondary'
              variant='contained'
              style={{ margin: '10px 0 0 0' }}
            >
              Submit
            </MuiButton>
          </Modal>
        }
      </>
    )
  }

  return (
    <OuterWrapper>
      {wordHighlighter && chunks?.length > 0
        ? chunks.map((chunk, index) => {
          const text = textToHighlight.substr(
            chunk.start,
            chunk.end - chunk.start
          )
          return <>
            { chunk.isHighlight
              ? <i key={text} className='highlight'>{text}</i>
              : <React.Fragment key={text}>{text}</React.Fragment>
            }
          </>
        })
        : text
      }
    </OuterWrapper>
  )
}

Highlighter.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string
}

export default Highlighter
